import { Component } from '@angular/core';
import { Zoom } from '../../common/enums/zoom';
import Phaser from 'phaser';
import { ToolboxActionService } from '../../services/toolbox-action.service';

@Component({
  selector: 'app-toolbox',
  templateUrl: './toolbox.component.html',
  styleUrls: ['./toolbox.component.scss'],
})
export class ToolboxComponent {
  public ZoomType = Zoom;
  public phaser!: Phaser.Game;

  constructor(public toolboxActionService: ToolboxActionService) {}

  public preventEvent(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }
}
